module.exports = __webpack_public_path__ + "static/img/shape_10.0a2c9d4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/shape_10.png
// module id = rDjS
// module chunks = 0